/**
 * Size guide with optional CM / INCH unit switch.
 */
class SizeGuide extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.hasAttribute('data-has-unit-switch')) return;

    /** @type {NodeListOf<HTMLButtonElement>} */
    const tabs = this.querySelectorAll('[data-unit]');
    /** @type {NodeListOf<HTMLElement>} */
    const panels = this.querySelectorAll('[data-unit-panel]');

    /**
     * Shows the selected unit panel and updates tab state.
     * @param {string} unit - Active unit (`cm` or `inch`).
     */
    const showUnit = (unit) => {
      panels.forEach((panel) => {
        const isActive = panel.dataset.unitPanel === unit;
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', String(!isActive));
      });

      tabs.forEach((tab) => {
        const isActive = tab.dataset.unit === unit;
        tab.toggleAttribute('active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => showUnit(tab.dataset.unit));

      tab.addEventListener('keydown', (event) => {
        const keys = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'];
        if (!keys.includes(event.key)) return;

        event.preventDefault();
        const tabList = Array.from(tabs);
        const currentIndex = tabList.indexOf(tab);
        const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
        const nextIndex = (currentIndex + direction + tabList.length) % tabList.length;
        const nextTab = tabList[nextIndex];

        showUnit(nextTab.dataset.unit);
        nextTab.focus();
      });
    });
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide);
}
